import AsyncStorage from '@react-native-async-storage/async-storage';
import {checkToken, getTokenByUniqueId} from '../API/base';
import {useEffect, useState} from 'react';
import {useNavigation} from '@react-navigation/native';
import {useDispatch} from 'react-redux';
import {saveUserInfo} from '../store/user';
import {navigationRef} from '../layout/Router';
import {getUniqueIdAuto} from '../hooks/useGetDeviceInfo';

export function saveToken(token) {
  return AsyncStorage.setItem('token', token);
}

export function getToken(token) {
  return AsyncStorage.getItem('token');
}

export function removeToken() {
  return AsyncStorage.removeItem('token');
}

export function logout() {
  return removeToken().then(() => {
    navigationRef.current?.reset({
      index: 0,
      routes: [{name: 'Login'}],
    });
  });
}

export async function getTokenByRequest(check = false) {
  let token = await getToken();
  if (!token || check) {
    const uniqueId = await getUniqueIdAuto();
    const res = await getTokenByUniqueId(uniqueId);
    token = res.data.jwtToken;
    await saveToken(token);
  }
  return token;
}

export function useToken(check = false) {
  const [token, setToken] = useState('');
  useEffect(() => {
    (async () => {
      let token2 = await getToken();
      setToken(token2);
    })();
  }, []);
  return {
    token,
    getToken() {
      return getTokenByRequest(check);
    },
  };
}

export function useCheckToken(isCheckAuto = true) {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [token, setToken] = useState('');
  useEffect(() => {
    if (!isCheckAuto) {
      return;
    }
    (async () => {
      let token2 = await getToken();
      if (token2) {
        const res = await checkToken();
        if (res.status !== 200) {
          navigation.replace('Login');
          return;
        } else {
          dispatch(saveUserInfo(res.data));
        }
      } else {
        navigation.replace('Login');
        return;
      }
      setToken(token2);
    })();
  }, [navigation]);
  return {
    token,
  };
}
